// #MODULE - ProductImage
// > Author: Michael Moir
// > Migrate: Balasubramanian Karthikesan
// > Create Date: Dec 29, 2016
//
// ##DESCRIPTION:
// This has utility functions to create Scene7 URLs

let regExForImagePath;

// ###Method - getImagePathFromImageUrl
// This function will extract just the filepath portion of a full Scene7 URL.  This is needed
// in order to reverse out the data point of the filepath, which can be compared to other filepath
// values consistently
//
// > parameters
// >
// + imageUrl - The full path of the imageUrl.
//
// > returns
// >
// + string - returns the filepath, or will return a blank string if it cannot parse out the filepath based on the known pattern.
function getImagePathFromImageUrl(imageUrl) {
  // STEP: Create the RegEx only once for this module for performance..can be reused
  // NOTE: This regex is looking for standard product path...will need to change if that ever changes!!!
  // This will return the path WITHOUT the leading slash per the current standard: (e.g. 1/optimized/2973371_fpx.tif)
  if (!regExForImagePath) {
    regExForImagePath = new RegExp(/\d\/optimized\/\d+_fpx.tif/i);
  }
  if (imageUrl) {
    const match = regExForImagePath.exec(imageUrl);
    if (match && match.length) {
      return match[0].toString();
    }
  }
  return '';
}

export default {
  getImagePathFromImageUrl(imgUrl) {
    return getImagePathFromImageUrl(imgUrl);
  },
};
